import React, { useEffect } from 'react'
import * as styles from './categoryProductCard.module.scss'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Link } from "gatsby"
import { useLocalPath } from '../hooks/useLocalPath'
import { useLocale } from '../../fragments/hooks/useLocale'
const CategoryProductCard = ({data}) => {
    const {slug, thumbnailImage, thumbnailTitle, sku, priceFirstId, wtbFirstId} = data
    const locale = useLocale()

    const adimoTouchpointIds = [priceFirstId, wtbFirstId].filter(Boolean).join(',')    

    const ratings = (locale) =>{
        
        switch(locale){
            case 'en-CA':
                return (
                    <>
                        <div className={styles.rating}>
                            <div data-bv-show="inline_rating" data-bv-product-id={sku}></div>
                        </div>
                        <a href='https://www.amazon.ca/stores/TAZO/page/6F8C3F11-A546-4887-B2F4-8305958B0DDA?ref_=ast_bln' target='_blank'>
                            <button className={styles.buyButton}>
                                Buy Online
                            </button>
                        </a>
                    </>
                )
            case 'fr-CA':
                return(
                    <>
                        <div className={styles.rating}>
                            <div data-bv-show="inline_rating" data-bv-product-id={sku}></div>
                        </div>
                        <a href='https://www.amazon.ca/stores/TAZO/page/6F8C3F11-A546-4887-B2F4-8305958B0DDA?ref_=ast_bln' target='_blank'>
                            <button className={styles.buyButton}>
                                ACHETER
                            </button>
                        </a>
                    </>
                )
            default:
                return(
                    <>
                        <div className={styles.rating}>
                            <div data-bv-show="inline_rating" data-bv-product-id={sku}></div>
                        </div>
                        <div className={styles.btn}>
                            <AdimoBuyNowBtn touchpointIds={adimoTouchpointIds} />
                        </div>
                    </>
                )
        }
    }
    return (
        <Link to = {useLocalPath(slug)} className={styles.cardWrapper}>
            <div className={styles.card}>
                <div className={styles.cardImage}>
                    <GatsbyImage
                        image={thumbnailImage.gatsbyImageData}
                        alt={`${thumbnailImage.title} image`}
                        loading="lazy"
                    />
                </div>
                <div>
                    <div className={styles.cardTitle}>
                        {thumbnailTitle}
                    </div>
                    {/* <div className={styles.rating}>
                        <div data-bv-show="inline_rating" data-bv-product-id={sku}></div>
                    </div>
                    <div className={styles.btn}>
                        <div className={`ps-widget `} ps-sku={sku}></div>
                    </div> */}
                    {/* <div className={styles.btn}>
                        <div className={`ps-widget $ `} ps-sku={sku}></div>
                    </div> */}
                    {/* <button className={styles.buyButton}>
                        Buy Online
                    </button> */}
                   
                </div>
                {ratings(locale)}
            </div>
        </Link>
    )
}

export default CategoryProductCard

const AdimoBuyNowBtn = ({ touchpointIds }) => {
    return (
        <button disabled={!touchpointIds} className={`adimo-multi-touchpoint ${styles.buyButton}`} data-type="multi-touchpoint-lightbox" data-static-touchpoint-identifiers={touchpointIds}>Buy Now</button>  
    )
  }